import React from 'react';

/**
 * Vorschau-Komponente für Transformationen.
 * Zeigt Ghost-Versionen der Objekte an der Zielposition.
 */
export function TransformPreview({ previewData, transformType }) {
  if (!previewData || previewData.length === 0) return null;

  // Farbe basierend auf Transformationstyp
  const color = transformType === 'copy' ? '#22c55e' : '#3b82f6';

  return (
    <group name="transform-preview">
      {previewData.map(item => (
        <group key={`preview-${item.id}`}>
          {/* Verbindungslinie von Original zu Preview */}
          <line>
            <bufferGeometry>
              <bufferAttribute
                attach="attributes-position"
                count={2}
                array={new Float32Array([
                  item.original.x, item.original.y, 5,
                  item.preview.x, item.preview.y, 5,
                ])}
                itemSize={3}
              />
            </bufferGeometry>
            <lineBasicMaterial color={color} linewidth={1} transparent opacity={0.3} />
          </line>

          {/* Ghost-Punkt an Zielposition */}
          <mesh position={[item.preview.x, item.preview.y, 5]}>
            <circleGeometry args={[80, 16]} />
            <meshBasicMaterial color={color} transparent opacity={0.5} />
          </mesh>
        </group>
      ))}
    </group>
  );
}

export default TransformPreview;
